

import Vue from 'vue'
import store from './store'
import App from './App'
import VueResource from 'vue-resource'
import Router from 'vue-router'
import router from './router'
import 'font-awesome/css/font-awesome.css'
import global_ from './vue/Global'

require('./assets/css/reset.css')

Vue.use(VueResource)
Vue.http.options.emulateJSON =false  
Vue.http.options.emulateHTTP = true


Vue.http.options.crossOrigin = true
Vue.http.options.xhr = {withCredentials: true}
Vue.http.headers.common['auth'] =localStorage.getItem("auth");
window.Vue = Vue
Vue.prototype.GLOBAL = global_
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

Vue.use(LoadingPlugin)
Vue.use(ToastPlugin)
Vue.use(ConfirmPlugin)
localStorage.setItem("jump",'')
Vue.http.interceptors.push((request, next) => {
next((res) => {//在响应之后传给then之前对response进行修改和逻辑判断。对于token时候已过期的判断，就添加在此处，页面中任何一次http请求都会先调用此处方法
if(res.status==401){
console.log('auth401...');
window.location.href='index.html#/login#';
}
});
});
/* eslint-disable no-new */
new Vue({
template: '<App/>',
router,
store,
components: { App }
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js